/**
 * Created by joerg on 20.05.17.
 */

import {observable} from 'mobx';
import shortid from 'shortid'
export default class SelectionOptionModel {
    @observable title;
    @observable value;
    @observable einheit;
    @observable disabled;
    key;

    constructor(title = "Option", value = "Option", einheit="", disabled = false) {
        this.title = title;
        this.value = value;
        this.einheit = einheit;
        this.disabled = disabled;
        this.key = shortid.generate()

    }
}


// WEBPACK FOOTER //
// ./src/models/SelectionOptionModel.js